import ReactDOMServer from 'react-dom/server';
import { TimeElement } from '../../TimeElement/TimeElement';
import type { WinterBikeRoadsSthOptions } from '../Layers/Layers.types';

export default function WinterBikeRoadsSthTemplate(_properties: unknown, layerOptions: WinterBikeRoadsSthOptions): string {
    return ReactDOMServer.renderToStaticMarkup(
        <div className="popup">
            <div className="popup-type">Vintercykelväg</div>
            <h3>{layerOptions.name}</h3>
            <table>
                <tbody>
                    <tr>
                        <td>Väghållare:</td>
                        <td>{layerOptions.name}</td>
                    </tr>
                    <tr>
                        <td>Metod för vinterväghållning:</td>
                        <td>{layerOptions.method}</td>
                    </tr>
                    {layerOptions.frequency != null && (
                        <tr>
                            <td>Frekvens:</td>
                            <td>{layerOptions.frequency}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <div className="popup-details">
                <dl>
                    <dt>Källa:</dt>
                    <dd>
                        <a
                            href={layerOptions.url}
                            target="_blank"
                            title={`Länk till ${layerOptions.baseUrl}. Öppnas i nytt fönster`}
                            rel="noreferrer"
                        >
                            {layerOptions.name}
                        </a>
                    </dd>
                    <dt>Uppdaterad:</dt>
                    <dd title={layerOptions.updated}>
                        <TimeElement dateTimeString={layerOptions.updated}>{layerOptions.updated}</TimeElement>
                    </dd>
                </dl>
            </div>
        </div>,
    );
}
